import './FilterPropValue.css';
import React, {useEffect, useState} from 'react';
import {decode} from 'html-entities';

function FilterPropValue(props) {

  const enValue = props.VALUE_EN && props.VALUE_EN.trim() !== '' && !props.VALUE.includes(props.VALUE_EN)
    ? `(${props.VALUE_EN})`
    : '';

  function onClick(event) {
    event.preventDefault();
    if (props.notAsync) {
      window.location.href = props.SMART_URL;
    } else if (props.NEED_REDIRECT) {
      window.location.href = props.REDIRECT_URL;
    } else {
      props.onChange(props.ASYNC_URL);
    }
  }

  return (
      <li className={`filter-item`}>
        <div className="checkbox">
          <label
              data-role={`label_${props.CONTROL_ID}`}
              htmlFor={props.CONTROL_ID}>
            <span className="input-checkbox">
              <input type="checkbox"
                     id={props.CONTROL_ID}
                     name={props.CONTROL_NAME}
                     checked={props.CHECKED && props.CHECKED === true
                         ? 'checked'
                         : ''}
                     onChange={event => {

                     }}/>
              <span className="checkbox-text" onClick={onClick}>
                {props.SHOW_LINK ? (
                    <a href={props.SMART_URL} className="filter-checkbox">
                      {decode(props.VALUE)}&nbsp;{enValue}
                    </a>
                ) : (
                  <span className="filter-checkbox">
                    {decode(props.VALUE)}&nbsp;{enValue}
                  </span>
                )}
                &nbsp;
                <span className="count">{`(${props.ELEMENT_COUNT})`}</span>
              </span>
            </span>
          </label>
        </div>
      </li>
  );
};

export default FilterPropValue;